import uuid from 'uuid/v4';

export const version = () => '3.0.4';

export const getDUID = () => `SSSP-${uuid().toUpperCase()}`;
// export const getDUID = () => {
//   return webapis.productinfo.getDuid().toUpperCase();
// };

export const getDeviceId = () => {
  // NOTE: This is for backwards compatibility and can be removed once all users are using the new version of the app.
  // Old versions of the app stored the SSSPDeviceId in localStorage and this allows the new version of our store
  // to use that existing device id, so that users do not have to re-pair.
  const currentDeviceId = localStorage.getItem('bd-android-app__device-id');
  localStorage.removeItem('bd-android-app__device-id');

  if (currentDeviceId !== null) {
    return currentDeviceId;
  }

  const newId = getDUID();
  return newId;
};
